<script lang="ts" setup>
  import { userAction } from '../../../shared/observability/userAction.ts';
  import { Button } from '../../../shared/ui/button';
  import { Logo } from '../../../shared/ui/logo';
  import { LogoText } from '../../../shared/ui/logo-text';
  import { MobileViewLayout } from '../../../shared/ui/mobile-view-layout';
  import HostGameLink from './HostGameLink.vue';

  defineEmits<{ joinGame: []; hostGame: [] }>();
</script>

<template>
  <MobileViewLayout justify="center" space="xl">
    <div class="group">
      <Logo />
      <LogoText id="songstar-text" text="Songstar" />
    </div>
    <div class="group">
      <Button :data-faro-user-action-name="userAction.indexJoinGame" @click="$emit('joinGame')">Join Game</Button>
      <HostGameLink :data-faro-user-action-name="userAction.indexHostGame" @click="$emit('hostGame')">
        Host Game
      </HostGameLink>
    </div>
  </MobileViewLayout>
</template>

<style scoped>
  .group {
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  #songstar-text {
    font-size: var(--font-size-3xl);
  }
</style>
